export default (editor, config = {}) => {
    const tm = editor.TraitManager;

    tm.addType('focal-point', {
        createInput({ trait }) {
            const component = trait.target;
            const property = trait.get('property') || 'background-position';

            const currentStyle = component.getStyle();
            const currentValue = currentStyle[property] || '50% 50%';
            const parts = currentValue.split(' ');
            let x = parseFloat(parts[0]) || 50;
            let y = parseFloat(parts[1]) || 50;

            const getImgSrc = () => {
                if (property === 'object-position') {
                    return component.getAttributes().src || '';
                }
                const bg = component.getStyle()['background-image'] || '';
                return bg.replace(/url\(['"]?/, '').replace(/['"]?\)$/, '');
            };

            const wrapper = document.createElement('div');
            wrapper.style.cssText = 'display:flex;flex-direction:column;gap:8px;width:100%;';

            const labelEl = document.createElement('div');
            labelEl.textContent = trait.get('label') || 'Fokuspunkt-Auswahl';
            labelEl.style.cssText = 'font-size:14px;font-weight:500;margin-bottom:2px;margin-top:2px;';
            wrapper.appendChild(labelEl);

            const previewWrapper = document.createElement('div');
            previewWrapper.style.cssText = 'position:relative;width:100%;padding-bottom:60%;background:#1a1a2e;border-radius:6px;overflow:hidden;cursor:crosshair;border:1px solid #444;';

            const previewImg = document.createElement('div');
            const imgSrc = getImgSrc();
            previewImg.style.cssText = `position:absolute;inset:0;background-size:cover;background-repeat:no-repeat;background-position:${x}% ${y}%;`;
            if (imgSrc) {
                previewImg.style.backgroundImage = `url(${imgSrc})`;
            } else {
                previewImg.style.background = 'linear-gradient(135deg,#2a2a4a 0%,#1a1a2e 100%)';
                const placeholder = document.createElement('div');
                placeholder.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#666;font-size:11px;';
                placeholder.textContent = 'Kein Bild';
                previewWrapper.appendChild(placeholder);
            }
            previewWrapper.appendChild(previewImg);

            const dot = document.createElement('div');
            dot.style.cssText = `position:absolute;width:22px;height:22px;border-radius:50%;border:2px solid #4a9eff;background:rgba(74,158,255,0.25);box-shadow:0 0 0 1px rgba(0,0,0,0.5);transform:translate(-50%,-50%);pointer-events:none;left:${x}%;top:${y}%;transition:left 0.05s,top 0.05s;`;
            previewWrapper.appendChild(dot);

            const crossH = document.createElement('div');
            crossH.style.cssText = `position:absolute;height:1px;background:rgba(74,158,255,0.4);top:${y}%;left:0;right:0;transform:translateY(-50%);pointer-events:none;`;
            const crossV = document.createElement('div');
            crossV.style.cssText = `position:absolute;width:1px;background:rgba(74,158,255,0.4);left:${x}%;top:0;bottom:0;transform:translateX(-50%);pointer-events:none;`;
            previewWrapper.appendChild(crossH);
            previewWrapper.appendChild(crossV);

            const inputsRow = document.createElement('div');
            inputsRow.style.cssText = 'display:flex;gap:8px;align-items:center;';

            const makeInputGroup = (labelText, val) => {
                const group = document.createElement('div');
                group.style.cssText = 'display:flex;align-items:center;gap:5px;flex:1;background:#2a2a3e;border:1px solid #444;border-radius:4px;padding:4px 8px;';
                const label = document.createElement('span');
                label.textContent = labelText;
                label.style.cssText = 'font-size:11px;color:#aaa;min-width:28px;';
                const input = document.createElement('input');
                input.type = 'number';
                input.min = '0';
                input.max = '100';
                input.step = '1';
                input.value = Math.round(val);
                input.style.cssText = 'flex:1;min-width:0;width:40px;background:transparent;border:none;color:#fff;font-size:12px;text-align:right;outline:none;';
                const pct = document.createElement('span');
                pct.textContent = '%';
                pct.style.cssText = 'color:#666;font-size:11px;';
                group.append(label, input, pct);
                return { group, input };
            };

            const { group: xGroup, input: xInput } = makeInputGroup('Links', x);
            const { group: yGroup, input: yInput } = makeInputGroup('Oben', y);
            inputsRow.append(xGroup, yGroup);

            const updatePosition = (newX, newY) => {
                x = Math.max(0, Math.min(100, newX));
                y = Math.max(0, Math.min(100, newY));
                dot.style.left = `${x}%`;
                dot.style.top = `${y}%`;
                crossH.style.top = `${y}%`;
                crossV.style.left = `${x}%`;
                previewImg.style.backgroundPosition = `${x}% ${y}%`;
                xInput.value = Math.round(x);
                yInput.value = Math.round(y);
                component.addStyle({ [property]: `${Math.round(x)}% ${Math.round(y)}%` });
            };

            const getPos = (e) => {
                const rect = previewWrapper.getBoundingClientRect();
                const clientX = (e.touches ? e.touches[0].clientX : e.clientX);
                const clientY = (e.touches ? e.touches[0].clientY : e.clientY);
                return {
                    newX: ((clientX - rect.left) / rect.width) * 100,
                    newY: ((clientY - rect.top) / rect.height) * 100,
                };
            };

            let isDragging = false;
            previewWrapper.addEventListener('pointerdown', (e) => {
                isDragging = true;
                previewWrapper.setPointerCapture(e.pointerId);
                const { newX, newY } = getPos(e);
                updatePosition(newX, newY);
                e.preventDefault();
            });
            previewWrapper.addEventListener('pointermove', (e) => {
                if (!isDragging) return;
                const { newX, newY } = getPos(e);
                updatePosition(newX, newY);
            });
            previewWrapper.addEventListener('pointerup', () => { isDragging = false; });

            xInput.addEventListener('change', () => updatePosition(parseFloat(xInput.value) || 0, y));
            yInput.addEventListener('change', () => updatePosition(x, parseFloat(yInput.value) || 0));

            wrapper.append(previewWrapper, inputsRow);
            wrapper._xInput = xInput;
            wrapper._yInput = yInput;
            wrapper._dot = dot;
            wrapper._crossH = crossH;
            wrapper._crossV = crossV;
            wrapper._previewImg = previewImg;

            return wrapper;
        },

        onUpdate({ elInput, component, trait }) {
            if (!elInput._xInput) return;
            const property = trait.get('property') || 'background-position';
            const style = component.getStyle();
            const value = style[property] || '50% 50%';
            const parts = value.split(' ');
            const x = parseFloat(parts[0]) || 50;
            const y = parseFloat(parts[1]) || 50;

            elInput._xInput.value = Math.round(x);
            elInput._yInput.value = Math.round(y);
            elInput._dot.style.left = `${x}%`;
            elInput._dot.style.top = `${y}%`;
            elInput._crossH.style.top = `${y}%`;
            elInput._crossV.style.left = `${x}%`;
            elInput._previewImg.style.backgroundPosition = `${x}% ${y}%`;

            if (property === 'object-position') {
                const src = component.getAttributes().src || '';
                if (src) elInput._previewImg.style.backgroundImage = `url(${src})`;
            } else {
                const bg = component.getStyle()['background-image'] || '';
                const src = bg.replace(/url\(['"]?/, '').replace(/['"]?\)$/, '');
                if (src) elInput._previewImg.style.backgroundImage = `url(${src})`;
            }
        },

        onEvent() {},
    });

};
